import actionTypes from '../constants/action-types';

const disable = () => ({
  type: actionTypes.DISABLE,
});

export default disable;
